








import Vue from 'vue'
import FontPicker from 'font-picker-vue'

export default Vue.extend({
  name: 'FontSelector',
  props: {
    font: {
      type: String,
      required: true
    }
  },
  components: {
    'font-picker': FontPicker
  }
})
